import Vue from 'vue';
import Router from 'vue-router';

import Login from './views/Login';
import Dashboard from './views/Dashboard';

import ClientsList from './views/ClientsList';
import ClientNew from './views/ClientNew';
import ClientEdit from './views/ClientEdit';
import ContractEdit from '@/components/client/ContractEdit';

import ExecutionsList from "./views/ExecutionsList";

import BailiffsList from './views/BailiffsList';
import BailiffNew from './views/BailiffNew';
import BailiffEdit from './views/BailiffEdit';

import CompaniesList from './views/CompaniesList';
import CompanyNew from './views/CompanyNew';
import CompanyEdit from './views/CompanyEdit';

import SchedulesList from './views/SchedulesList';
import ScheduleNew from './views/ScheduleNew';

import Holidays from './views/Holidays';

import Dictionary from './views/Dictionary';
import DictionaryEdit from './views/DictionaryEdit';
import DictionaryNew from './views/DictionaryNew';

import ExpensesList from './views/ExpenseList';
import ExpenseEdit from './views/ExpenseEdit';
import ExpenseNew from './views/ExpenseNew';

import CourtsList from './views/CourtsList';

import InvoicesList from './views/InvoicesList';

import Raports from './views/Raports';

import store from './store/index';

Vue.use(Router);


function requireAuth (to, from, next) {
    /*
        Determines where we should send the user.
    */
    function proceed () {
        /*
            If the user has been loaded determine where we should
            send the user.
        */
        if ( store.getters.getUserLoadStatus() == 2 ) {
            if(store.getters.getUser.is_admin === 2){
                // Jesli konto z dostepem do spolek to wowczas moze miec dostep tylko do kilku zakladek
                if(!store.getters.getShortAccessModules.includes(to.name)){
                    next({
                        name: 'dashboard',
                    });
                }
                else{
                    next();
                }
            }
            else{
                /*
                If the user is not empty, that means there's a user
                authenticated we allow them to continue. Otherwise, we
                send the user back to the home page.
            */
                next();
            }
        }

        else{
            next({
              name: 'login',
              query: {
                nextUrl: to.fullPath,
              }});
        }
    }

    /*
        Confirms the user has been loaded
    */
    if ( store.getters.getUserLoadStatus() != 2 ) {

        /*
            If not, load the user
        */

        store.dispatch( 'loadUser' );

        /*
            Watch for the user to be loaded. When it's finished, then
            we proceed.
        */

        if(store.getters.getUserLoadStatus() == 3){
          next({
            name: 'login',
            query: {
              nextUrl: to.fullPath,
            }});
        }

        store.watch( store.getters.getUserLoadStatus, function(){

            if( store.getters.getUserLoadStatus() == 2 ){
                proceed();
            }
        });
    } else {
        /*
            User call completed, so we proceed
        */

        proceed()
    }
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      name: 'login',
      path: '/logowanie',
      component: Login,
      meta: {
        layout: 'login'
      }
    },
    {
      path: '/',
      redirect: '/dashboard'
    },
    {
      name: 'dashboard',
      path: '/dashboard',
      component: Dashboard,
      beforeEnter: requireAuth
    },
    {
      name: 'dictionary',
      path: '/słowniki',
      component: Dictionary,
      beforeEnter: requireAuth
    },
    {
      name: 'dictionary-edit',
      path: '/słowniki/edycja/:id/',
      component: DictionaryEdit,
      beforeEnter: requireAuth
    },
    {
      name: 'dictionary-new',
      path: '/słowniki/nowy',
      component: DictionaryNew,
      beforeEnter: requireAuth
    },
    {
      path: '/klienci',
      name: 'clients-list',
      component: ClientsList,
      beforeEnter: requireAuth
    },
    {
      path: '/raporty',
      name: 'raports',
      component: Raports,
      beforeEnter: requireAuth
    },
    {
      path: '/klienci/edycja/:id',
      name: 'client-edit',
      component: ClientEdit,
      beforeEnter: requireAuth,
    },
    {
      path: '/klienci/edycja/:client_id/:schedule_id/:case_id?',
      name: 'contract-edit',
      component: ContractEdit,
      beforeEnter: requireAuth
    },
    {
      path: '/klienci/nowy',
      name: 'client-new',
      component: ClientNew,
      beforeEnter: requireAuth
    },
    {
      path: '/harmonogramy',
      name: 'schedules-list',
      component: SchedulesList,
      beforeEnter: requireAuth
    },
    {
      path: '/harmonogramy/nowy',
      name: 'schedule-new',
      component: ScheduleNew,
      beforeEnter: requireAuth
    },
    {
      path: '/harmonogramy-wewnętrzne',
      name: 'schedules-list-internal',
      component: SchedulesList,
      beforeEnter: requireAuth,
      props: { isInternal: true }
    },
    {
      path: '/spolki',
      name: 'companies-list',
      component: CompaniesList,
      beforeEnter: requireAuth
    },
    {
      path: '/egzekucje',
      name: 'executions-list',
      component: ExecutionsList,
      beforeEnter: requireAuth
    },
    {
      path: '/komornicy',
      name: 'bailiffs-list',
      component: BailiffsList,
      beforeEnter: requireAuth
    },
    {
      path: '/komornicy/nowy',
      name: 'bailiff-new',
      component: BailiffNew,
      beforeEnter: requireAuth
    },
    {
      path: '/komornicy/edycja/:id',
      name: 'bailiff-edit',
      component: BailiffEdit,
      beforeEnter: requireAuth
    },
    {
      path: '/faktury',
      name: 'invoices-list',
      component: InvoicesList,
      beforeEnter: requireAuth
    },
    {
      path: '/wydatki',
      name: 'expenses-list',
      component: ExpensesList,
      beforeEnter: requireAuth
    },
    {
      path: '/wydatki/edycja/:id',
      name: 'expense-edit',
      component: ExpenseEdit,
      beforeEnter: requireAuth
    },
    {
      path: '/wydatki/nowy',
      name: 'expense-new',
      component: ExpenseNew,
      beforeEnter: requireAuth
    },
    {
      path: '/sady',
      name: 'courts-list',
      component: CourtsList,
      beforeEnter: requireAuth
    },
    {
      path: '/spolki/edycja/:id',
      name: 'company-edit',
      component: CompanyEdit,
      beforeEnter: requireAuth
    },
    {
      path: '/spolki/nowy',
      name: 'company-new',
      component: CompanyNew,
      beforeEnter: requireAuth
    },
    {
      path: '/swieta',
      name: 'holidays',
      component: Holidays,
      beforeEnter: requireAuth
    },
  ],
});
